import {Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Typography} from "@mui/material";
import {observer} from "mobx-react-lite";
import {useState} from "react";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import styles from "../filter/filterbar.module.scss";

import {Slider} from '@mui/material';

export interface FilterSpeedProps {

    setValue: any

}

const FilterBarSpeed = ({setValue}: FilterSpeedProps) => {
    const [selectOpen, setSelectIsOpen] = useState(false)
    const [speedValue, setSpeedValue] = useState<number[]>([0, 160]);

    const handleSpeedChange = (event: Event, newSpeedValue: any) => {
        setSpeedValue(newSpeedValue);
        setValue(newSpeedValue);
    };


    return (
        <div className={styles.filterGroup}>
            <FormControl required={false} fullWidth variant="standard" className={styles.filterGroupSlider}>


                <Typography className={styles.filterLabel}>{'Speed'}</Typography>

                <Slider
                    className={styles.filterSlider}
                    value={speedValue}
                    onChange={handleSpeedChange}
                    valueLabelDisplay="on"

                    size="small"
                    sx={
                        {
                            color: '#607D8B',
                            height: 5,
                            '& .MuiSlider-track': {
                                border: 'none',
                                color: '#E53935',

                            },
                            '& .MuiSlider-thumb': {
                                height: 14,
                                width: 14,
                                backgroundColor: '#fff',
                                border: '2px solid #E53935',
                                '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
                                    boxShadow: 'inherit',
                                },
                                '&::before': {
                                    display: 'none',
                                },
                            },
                            '& .MuiSlider-valueLabel': {

                                color: '#607D8B !important',
                                fontFamily: 'Everett Regular',
                                fontSize: '12px',
                                fontWeight: '400',
                                lineHeight: '150%',
                                top:0,
                                backgroundColor: 'unset',

                                '&::before': {
                                    display: 'none',
                                },
                                '& *': {
                                    background: 'transparent',
                                    color: '#607D8B',

                                },


                            },
                        }

                    }
                    min={0}
                    max={200}

                    aria-label="speed range slider"
                />


            </FormControl>
        </div>
    )
}

export default observer(FilterBarSpeed);